import './Login.css';
import FancyInput from '../../ui/FancyInput/FancyInput';
import Branding from '../../ui/branding/Branding';
import { useState, useEffect} from "react"
import PencilBanner from '../../dialogs/PencilBanner/PencilBanner';
import FancyCheckbox from '../../ui/FancyCheckbox/FancyCheckbox';
import CtaButton from '../../ui/CtaButton/CtaButton';
import { faEnvelope, faAt, faKey, faArrowRightToBracket } from '@fortawesome/free-solid-svg-icons'
// import authUser from './api/Auth.js';

export default function LogIn({setUserCallback}){
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [rememberMe, setRememberMe] = useState(false);
  const [loggingIn, setLoggingIn] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const rememberMeChanged = (toggle) =>{
    setRememberMe(toggle);
  }

  useEffect(()=>{

  }, [])
  const login = () => {
    setLoggingIn(true);
    fetch("http://localhost:80/api/v2/auth/getToken.php", {mode: 'cors', method: 'POST', body: JSON.stringify({username: username, password:password})})
    .then(response => response.json())
    .then(data => {
      if(data.status === 200){
        setUserCallback(data);
      }else{
        setLoggingIn(false);
        setErrorMessage(data.message);

      }
    })
    .catch(error => {
      setErrorMessage(error.message);
      setLoggingIn(false);
    })
    setTimeout(()=>{
      setErrorMessage(null);
    }, 6000)
  }

  const forceLogin=()=>{
    setUserCallback({api:"aassddas"});
  }
    return(
      <>
        <div className="login-wrapper">
   
          <div className="login-form">
          <Branding size="large" />
            <FancyInput width={105} label="Email" icon={faAt} onChangeCallback={(event) => {setUsername(event.currentTarget.value)}}/>
            <FancyInput width={105} label="Password" icon={faKey} type="password" onChangeCallback={(event) => {setPassword(event.currentTarget.value)}}/>
            <FancyCheckbox startChecked={rememberMe} label="Remember Me, please..." checkChangeCallback={rememberMeChanged} />
            <CtaButton isLoading={loggingIn} text="Log In" icon={faArrowRightToBracket} onClickCallback={login} />
            <CtaButton isLoading={loggingIn} text="Force Login" icon={faArrowRightToBracket} onClickCallback={forceLogin} />
          </div>
        </div>

        <PencilBanner warning="warning" show={errorMessage === null ? rememberMe : false}>
          <h3>Wait a Minute!</h3>
          <p>You've asked to be remembered, how nice! Just make sure you're not using a public/shared PC!</p>
        </PencilBanner>

        <PencilBanner warning="error" show={errorMessage !== null}>
          <h3>Well, this is embarrassing.. </h3>
          <p>There was an error logging you in. <br /><code>{errorMessage}</code></p>
        </PencilBanner>
      </>
    )
  }   